<template>
  <div class="container-fluid">
    <div>
      <div class="row">
        <div class="col s3">
          <label>Region / Department</label>
        </div>
        <div class="col s3">
          <label>Visibility</label>
        </div>
      </div>
      <div v-for="(region, index) in sortedRegions" v-bind:key="index">
        <div class="row no-margin">
          <div class="col s3">
            <a class="clickable" @click="addOrRemoveTreeviewOpenRegions(region.RegionId)" v-show="region.Departments.length > 0">
              <i class="material-icons inline-icon" style="margin-top: 6px">{{ (treeview.openRegionIds.includes(region.RegionId) ? 'keyboard_arrow_down' : 'keyboard_arrow_right') }}</i>
              {{ region.Name }}
            </a>
            <a v-show="region.Departments.length === 0">
              <i class="material-icons inline-icon" style="margin-top: 6px">remove</i>
              {{ region.Name }}
            </a>
          </div>
          <div v-show="region.Departments.length > 0">
            <label>
              <input :id="region.RegionId" :ref="region.RegionId" type="checkbox" @click="setAllDepartmentsRegion(region.RegionId)" />
              <span></span>
            </label>
          </div>
        </div>
        <div v-show="region.Departments.length > 0">
          <div v-for="(department, index) in region.Departments" v-bind:key="index">
            <div class="row no-margin" v-show="treeview.openRegionIds.includes(region.RegionId)">
              <div class="col s3" style="margin-left: 36px; margin-top: 6px">
                <a class="clickable" @click="addOrRemoveTreeviewOpenDepartments(department.DepartmentId)">
                  {{ department.Name }}
                </a>
              </div>
              <div>
                <label>
                  <input :id="region.RegionId" type="checkbox" @click="setDepartment(department.DepartmentId)" :checked="(user.DepartmentIds.includes(department.DepartmentId) ? 'checked' : false)" />
                  <span></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    user: Object,
    regions: Array
  },
  computed: {
    sortedRegions: function () {
      return _.orderBy(this.regions, ['Name'], ['asc'])
    }
  },
  data: function () {
    return {
      treeview: {
        openRegionIds: [],
        openDepartmentIds: []
      }
    }
  },
  updated: function () {
    this.setCheckboxState()
  },
  mounted: function () {
    this.setCheckboxState()
  },
  methods: {
    checkIfUserHasAllDepartments: function (departments) {
      var hasAll = false
      if (departments !== null && departments !== undefined && departments.length > 0) {
        departments.forEach(dep => {
          if (this.user.DepartmentIds.includes(dep.DepartmentId)) {
            hasAll = true
          } else {
            hasAll = false
          }
        })
      }
      return hasAll
    },
    setCheckboxState: function () {
      // Empty the array of inditerminate checkboxes
      var state
      if (this.regions !== undefined) {
        this.regions.forEach(reg => {
          if (reg.Departments !== undefined && reg.Departments !== null) {
            var activeDepartmententsInRegion = 0

            reg.Departments.forEach(dep => {
              if (this.user.DepartmentIds.includes(dep.DepartmentId)) {
                state = 'indeterminate'
                activeDepartmententsInRegion++
              }
            })

            if (activeDepartmententsInRegion === reg.Departments.length) {
              state = 'checked'
            }

            if (state !== undefined) {
              if (state === 'indeterminate') {
                this.$refs[reg.RegionId][0].indeterminate = true
              }

              if (state === 'checked') {
                this.$refs[reg.RegionId][0].checked = 'checked'
                this.$refs[reg.RegionId][0].indeterminate = false
                // document.getElementById(reg.RegionId).checked = 'checked'
                // document.getElementById(reg.RegionId).indeterminate = false
              }
              state = undefined
            } else {
              this.$refs[reg.RegionId][0].checked = false
              this.$refs[reg.RegionId][0].indeterminate = false
              // document.getElementById(reg.RegionId).checked = false
              // document.getElementById(reg.RegionId).indeterminate = false
            }
          }
        })
      }
    },
    setAllDepartmentsRegion: function (regionId) {
      if (regionId !== undefined && this.regions.length > 0) {
        var region = this.regions.find(r => r.RegionId === regionId)
        var allDepartmentsInRegionLength = (region.Departments === null ? 0 : region.Departments.length)
        var allDepartmentsInUser = 0

        if (allDepartmentsInRegionLength > 0) {
          region.Departments.forEach(d => {
            if (this.user.DepartmentIds.includes(d.DepartmentId)) {
              allDepartmentsInUser++
            }
          })

          // Check if user has any of the departments in this region
          // if yes check all
          if (allDepartmentsInUser > 0 && allDepartmentsInUser < allDepartmentsInRegionLength) {
            region.Departments.forEach(d => {
              if (!this.user.DepartmentIds.includes(d.DepartmentId)) {
                this.user.DepartmentIds.push(d.DepartmentId)
              }
            })
          }

          // check if user has all of the departments in this region
          // if yes, uncheck all
          if (allDepartmentsInUser === allDepartmentsInRegionLength) {
            region.Departments.forEach(d => {
              this.user.DepartmentIds.splice(this.user.DepartmentIds.indexOf(d.DepartmentId), 1)
            })
          }

          // check if user has none of the departments in this region
          // if yes, check all
          if (allDepartmentsInUser === 0) {
            region.Departments.forEach(d => {
              this.user.DepartmentIds.push(d.DepartmentId)
            })
          }
        }
      }
    },
    setDepartment: function (deparmentId) {
      if (this.user.DepartmentIds.includes(deparmentId)) {
        this.user.DepartmentIds.splice(this.user.DepartmentIds.indexOf(deparmentId), 1)
      } else {
        this.user.DepartmentIds.push(deparmentId)
      }
    },
    addOrRemoveTreeviewOpenRegions: function (regionId) {
      if (this.treeview.openRegionIds.includes(regionId)) {
        this.treeview.openRegionIds.splice(this.treeview.openRegionIds.indexOf(regionId), 1)
      } else {
        this.treeview.openRegionIds.push(regionId)
      }
    },
    addOrRemoveTreeviewOpenDepartments: function (departmentId) {
      if (this.treeview.openDepartmentIds.includes(departmentId)) {
        this.treeview.openDepartmentIds.splice(this.treeview.openDepartmentIds.indexOf(departmentId), 1)
      } else {
        this.treeview.openDepartmentIds.push(departmentId)
      }
    }
  }
}
</script>

<style scoped>
.inline-icon {
   vertical-align: bottom;
}

[type="checkbox"]:not(:checked), [type="checkbox"]:checked {
    position: fixed !important;
    opacity: 0;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/_Department-visibility.vue